import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from '@kyruus/intl';
import { useCrmConnector as useCRM } from '@kyruus/crm-connector-widget';
import Cancel from '@kyruus/react-ikons/Cancel';
import Snackbar, { IconButton as SnackbarIconButton } from '@kyruus/snackbar';
import { MODULES, isModuleEnabled } from 'Common/config';
import { SEARCH_SHUFFLE_TOKEN, saveToken } from 'Common/logging/tokens';
import { messages } from './messages';
import { InvalidPatientDataBanner } from '../InvalidPatientData';

export const CrmConnectorContext = React.createContext();

export const CrmConnectorProvider = connect()(
  injectIntl(function CrmConnectorProvider({
    intl,
    log,
    config,
    machineOptions = {},
    ...props
  }) {
    const enabled = isModuleEnabled(config, MODULES.CRM_INTEGRATION);
    const isBookingEnabled = isModuleEnabled(config, MODULES.DIRECT_BOOK);
    const crmConnector = useCRM({
      initialContext: { ...config?.crm, ...config?.referral },
      machineOptions: {
        ...machineOptions,
        actions: {
          ...(machineOptions.actions ? machineOptions.actions : {}),
          onInitialization: (ctx, event) => {
            if (enabled) {
              machineOptions?.actions?.onInitialization?.(ctx, event);
              log?.('crm.integration.initialization.success', ctx.envData);
            }
          },
          onInitializationError: (ctx, event) => {
            if (enabled) {
              machineOptions?.actions?.onInitializationError?.(ctx, event);
              log?.('crm.integration.initialization.error', ctx.envData);
            }
          },
          onPatientReceived: (_, event) => {
            if (event.data?.caseId != null) {
              if (machineOptions.actions.onPatientReceived) {
                machineOptions.actions.onPatientReceived(event.data.caseId);
              }

              saveToken({
                token: SEARCH_SHUFFLE_TOKEN,
                value: event.data.caseId
              });
            }
          }
        }
      }
    });

    const value = {
      enabled,
      connector: crmConnector
    };

    return (
      <>
        {enabled && crmConnector.hasErrors() ? (
          <Snackbar
            key={crmConnector.state.context.errors[0].type}
            mode="error"
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            open={
              crmConnector.hasErrors() &&
              crmConnector.state.context.errors[0].displayToUser
            }
            message={intl.formatMessage(
              messages[crmConnector.state.context.errors[0].type]
            )}
            onClose={(_, reason) => {
              if (reason !== 'clickaway') {
                crmConnector.dismissError();
              }
            }}
            action={
              <SnackbarIconButton
                color="inherit"
                onClick={crmConnector.dismissError}
              >
                <Cancel />
              </SnackbarIconButton>
            }
          />
        ) : null}
        {enabled && crmConnector.hasPatientValidationErrors() && (
          <InvalidPatientDataBanner
            crmState={crmConnector.state}
            isBookingEnabled={isBookingEnabled}
          />
        )}
        <CrmConnectorContext.Provider value={value} {...props} />
      </>
    );
  })
);
